// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2olhb","footer":"ModalCreateQualiphyProcedure_footer__3JWps","additionData":"ModalCreateQualiphyProcedure_additionData__1QOCH"};